<template>
  <div>
    <div class="head-box">
      <div class="c-flex c_flex_center">
        <h4>出险质保</h4>
      </div>
      <div class="c-flex c-flex-item">
        <el-input
          style="width:300px"
          placeholder="请输入委托方/业主手机号/工单编号"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button
          type="primary"
          class="c-m-l-10"
          @click="
            osg.doExport(
              {
                'in:state|integer#and': 1,
                'regex:ownerName|string#or': searchValue,
                'regex:ownerPhone|string#or': searchValue,
                'regex:serviceAppointmentNum|string#or': searchValue,
                sortField: 'createTime',
                sortOrder: 'desc',
                beanName: 'accidentWarranty',
                title: '出险质保'
              },
              { dynamic: true }
            )
          "
        >
          数据导出
        </el-button>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-blue c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table
          ref="table"
          height="calc(100% - 50px)"
          :data="fpi.data"
          v-if="refresh"
          highlight-current-row
          border
          @header-dragend="osg.colWidthChange"
        >
          <c-table :fields="extFields"></c-table>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  name: 'accidentWarrantys',
  data() {
    return {
      name: 'accidentWarranty',
      fpi: {},
      searchValue: '',
      openDetail: false,
      formData: {},
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      rules: this.$util.rules,
      options: {},
      state: '', //已归档 archived
      refresh: true //表格刷新
    };
  },
  beforeCreate() {
    window.$this = this;
  },
  async mounted() {
    this.doInit();
    this.osg.getFields('accidentWarranty', () => {
      this.osg.getFpi();
      this.getData();
    });
  },
  methods: {
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.openDetail = false;
      this.formData = { exts: {} };
      if (this.$refs.formData) this.$refs.formData.resetFields();
      this.$util.renderExtField(this.extFields, this.formData);
    },
    getData() {
      var params = {
        page: this.fpi.page,
        rows: this.fpi.rows,
        'in:state|integer#and': 1,
        'regex:ownerName|string#or': this.searchValue,
        'regex:ownerPhone|string#or': this.searchValue,
        'regex:serviceAppointmentNum|string#or': this.searchValue,
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      //添加过滤器参数
      window.$that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('basic/accidentWarranty/query.do', params, res => {
        this.refresh = false;
        this.fpi = res;
        this.refresh = true;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    }
  }
};
</script>
